import React from "react"
import type { Dispatch } from "react"
import type { IndicacoesAmigosModel } from "../models/indicacoesAmigosModel"
import { IndicacoesAmigosInicial } from "../models/indicacoesAmigosModel"
import type { IndicacoesAmigosActions } from "./indicacoesAmigosActions"

interface IndicacoesAmigosContextType {
    dados: IndicacoesAmigosModel
    dispatch: Dispatch<IndicacoesAmigosActions>
    erroCarregamento: string | null
}

export const IndicacoesAmigosContext = React.createContext<IndicacoesAmigosContextType>({
    dados: IndicacoesAmigosInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
})
